import React from 'react';
import styles from './css/LoadingWaves.module.css';

interface LoadingWavesProps {
  color: string;
}

export const LoadingWaves: React.FC<LoadingWavesProps> = ({ color }) => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingWaves}>
        <div className={styles.wave} style={{ backgroundColor: color }} />
        <div className={styles.wave} style={{ backgroundColor: color }} />
        <div className={styles.wave} style={{ backgroundColor: color }} />
        <div className={styles.wave} style={{ backgroundColor: color }} />
        <div className={styles.wave} style={{ backgroundColor: color }} />
      </div>
    </div>
  );
}; 